import React from 'react';

import styles from './GettingStartedCard.module.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Section } from 'components';
import { Row, Col } from 'react-bootstrap';

type GettingStartedCardProps = {};

export const GettingStartedCard: React.FC<GettingStartedCardProps> = React.memo(() => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.title}>{t(`getting-started-quick-title`)}</span>
      <Section>
        <Row><span>{t('getting-started-quick-guide-access')} <a target='_blank' rel='noreferrer noopener' href='/docs/Flo-By-Moen-Property-Water-Security-System.pdf'>{t('here')}</a>.</span></Row>
        <Row><span>{t('getting-started-quick-instructions-lead')}</span></Row>
        <Row>
          <ol>
            <li><Link to={'/users'}>{t('getting-started-quick-instructions-1-link')}</Link></li>
            <li><Link to={'/locations'}>{t('getting-started-quick-instructions-2')}</Link></li>
            <li>{t('getting-started-quick-instructions-3')}</li>
            <li>{t('getting-started-quick-instructions-4')}</li>
          </ol>
        </Row>
      </Section>

      <span className={styles.title}>{t(`getting-started-devices-title`)}</span>
      <Section>
        <Row><p>{t('getting-started-devices')}</p></Row>
        <Row>
        <ul>
          <li><a target='_blank' rel='noreferrer noopener' href='/docs/Flo-By-Moen-Smart-Water-Shutoff-Installation-Instructions.pdf'>Smart Water Shutoff</a></li>
          <li><a target='_blank' rel='noreferrer noopener' href='/docs/Flo-By-Moen-Cellular-Antenna-Installation-Instructions.pdf'>Cellular Atenna</a></li>
        </ul>
        </Row>
      </Section>

      <Section>
        <Row><span className={styles.title}>{t('getting-started-app-store-title')}</span></Row>
        <Row><p>{t('getting-started-app-store')}</p></Row>
        <Row>
          <Col>
            <a href='https://apps.apple.com/us/app/flo-by-moen-property/id1531704719'>
              <img
                height={60}
                className={styles.appStoreImage}
                src="/images/apple_app_store.png"
                alt="Generic placeholder"
              />
            </a>
          </Col>
          <Col>
            <a href='https://play.google.com/store/apps/details?id=com.flotechnologies.ent&hl=en_US&gl=US'>
              <img
                height={60}
                className={styles.appStoreImage}
                src="/images/google_play_store.png"
                alt="Generic placeholder"
              />
            </a>
          </Col>
        </Row>
      </Section>
    </div>
  )
});
